import { render } from "./api-clicks-table.vue?vue&type=template&id=33680d4c"
import script from "./api-clicks-table.vue?vue&type=script&lang=js"
export * from "./api-clicks-table.vue?vue&type=script&lang=js"

import "./api-clicks-table.vue?vue&type=style&index=0&id=33680d4c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__